import { IAvailabilityProductStore } from "./types";
import ActionTypes from '../../../constants/ActionTypes';

const initialState: IAvailabilityProductStore = {
  data: {
    storeId: 0,
    expectedDeliveryTime: "",
    latestDeliveryTime: "",
    code: 0,
  },
  isLoading: false
};

const availabilityProductReducer = (
  state = initialState,
  action: any,
): IAvailabilityProductStore => {
  switch (action.type) {
  case ActionTypes.AVAILABILITY_PRODUCT.SET:
    return {
      ...state,
      data: action.payload
    };
  case ActionTypes.AVAILABILITY_PRODUCT.SET_LOADER:
    return {
      ...state,
      isLoading: action.payload.isLoading
    };
  }

  return state;
};

export default availabilityProductReducer;
